import React from 'react';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import EssayAboutDefault from './Default';
import EssayAboutPlayful from './Playful';

export function EssayAbout(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();

  return isPlayfulStudentTheme ? <EssayAboutPlayful {...props} /> : <EssayAboutDefault {...props} />;
}
